<template>
	<div>
		<img :src="background" class="login-background">
		
		<div class="container-fluid login-page">
			<div class="row">
				<div class="quadro">
					<div class="body">
						<div class="container">
							<div class="row">
								<img class="mt-5" src="../assets/img/logo-lateral.png" width="100%">
							</div>

							<div class="row">
								<div class="col-lg-12 form">
									<transition mode="out-in" name="leftIn">
										<router-view></router-view>
									</transition>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import api 	  from '@/mixins/api.js'
	import router from '@/router/index.js'

	export default {
		data() {
			return {
				alert: "hidden",
				erro: "",

				params: {
					username: "",
					password: ""
				},
			}
		},

		mixins: [api],

		computed: {
			background() {
				return this.$store.state.config.bg_login
			}
		},

		methods: {
			async login() {
				const response = await this.POST("Auth/Login", this.params)

				if ( response.status == "error" ) {
					this.erro  = response.result
					this.alert = "show"

					setTimeout(() => {
						this.alert = "hidden"
						this.erro  = ""
					}, 5000);
				}

				else {
					this.$store.dispatch("update_user", response.user )
					localStorage.auth  = true
					localStorage.token = response.api_key
					router.push('/App');
				}
			}
		}
	}
</script>

<style>
</style>